/*** IMPORTS FROM imports-loader ***/


(function () {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['./index'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS-like environments that support module.exports, like Node.
        module.exports = require('./index');
        window.GisServerApis = module.exports; // inject to window scope.
    }
}());
